import React from "react";

import { ExportAmazonEditPolaris } from "./ExportAmazonEditPolaris";

export const ExportAmazonViewConfig = (props) => {
    return <ExportAmazonEditPolaris viewConfig {...props} />;
};
